goog.provide("Ntry.CommandPopup");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.CommandPopup = {
    pageIndex: 0,
    setPopupLayout: function (popup) {
        this.pageIndex = 0;
        this.exampleBadge_ = Entry.Dom('div', {
            class: 'entryPopupHelperExampleBadge'
        }).text(Lang.Menus.maze_command_ex);

        this.leftButton_ = Entry.Dom('div', {
            class: 'entryPopupHelperLeft',
        });
        
        this.leftButton_.bindOnClick((function () {
            this.setPrevStep();
        }).bind(this));

        this.rightButton_ = Entry.Dom('div', {
            class: 'entryPopupHelperRight'
        });
        this.rightButton_.bindOnClick((function () {
            this.setNextStep();
        }).bind(this));

        this.indicator_ = Entry.Dom('div', {
            class: 'entryPopupHelperIndicator'
        });

        if(this.content.length > 1) {
            var hr = Entry.Dom('hr', {
                class: 'indicatorHr'
            });
            this.indicator_.append(hr);
            var indicator = Entry.Dom('span', {
                class: 'indicator'
            });
            for(var i = 0; i < this.content.length; i++) {
                var dom = indicator.clone(true);
                this.indicator_.append(dom);
            }
            var that = this;
            this.indicator_.off().on('click', 'span:not(.on)', function () {
                var index = that.indicator_.find('span').index(this);
                that.setNthStep(index);
            });
            this.indicator_.addClass('show');
        }

        this.content_ = Entry.Dom('div', {
            class: 'entryPopupHelperContent'
        });
        this.contentCommand_ = Entry.Dom('div', {
            class: 'entryPopupHelperContentCommand'
        });
        this.contentDesc_ = Entry.Dom('div', {
            class: 'entryPopupHelperContentDesc'
        });
        var wrapper = Entry.Dom('div');

        wrapper.append(this.leftButton_);
        wrapper.append(this.rightButton_);
        wrapper.append(this.contentCommand_);
        wrapper.append(this.contentDesc_);
        wrapper.append(this.exampleBadge_);
        wrapper.append(this.content_);
        wrapper.append(this.indicator_);
        popup.popupWrapper_.append(wrapper);

        popup.addClass('commandPopupWindow');
        this.setContent(this);
    },
    setContent: function () {
        if(this.content.length > 1) {
            if(this.pageIndex === 0) {
                this.rightButton_.addClass('show');
                this.leftButton_.removeClass('show');
            } else if(this.pageIndex === this.content.length - 1) {
                this.leftButton_.addClass('show');
                this.rightButton_.removeClass('show');
            } else {
                this.rightButton_.addClass('show');
                this.leftButton_.addClass('show');
            }

            this.indicator_.find('span').removeClass('on');
            this.indicator_.find('span:eq('+ this.pageIndex +')').addClass('on');
        } else {
            this.rightButton_.removeClass('show');
            this.leftButton_.removeClass('show');
        }

        var nowContent = this.content[this.pageIndex];
        this.contentCommand_.html('<span>' + nowContent.command + '</span>');
        this.contentDesc_.html(nowContent.description);
        this.content_.html('');
        nowContent.images.forEach((function (item) {
            var elem = Entry.Dom('div');
            elem.addClass(item);
            this.content_.append(elem);
        }).bind(this));
    },
    setNthStep: function (idx) {
        this.pageIndex = idx;
        this.setContent();
    },
    setNextStep: function () {
        this.pageIndex++;
        this.setContent();
    },
    setPrevStep: function () {
        this.pageIndex--;
        this.setContent();
    },
    onShow: function() {
        // this.pageIndex = 0;
        // this.setContent();
    }
};